import React from 'react';
import { X } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

const FullMenuModal = ({ isOpen, onClose }) => {
  const menuImages = [
    {
      url: 'https://customer-assets.emergentagent.com/job_n1-grill-london/artifacts/kmh9lstt_Resized_IMG-20260111-WA0006.JPEG',
      title: 'Doner & Wrap Meals'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_n1-grill-london/artifacts/8y2ee0ww_Resized_IMG-20260111-WA0007.JPEG',
      title: 'Chicken & Wings Meals'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_n1-grill-london/artifacts/jfhs5n3f_Resized_IMG-20260111-WA0008.JPEG',
      title: 'Peri Peri Meals & Family Platters'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_n1-grill-london/artifacts/o52skuz5_Resized_IMG-20260111-WA0009.JPEG',
      title: 'Signature New Additions'
    }
  ];

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-6xl max-h-[90vh] bg-black border-2 border-orange-500/50 p-0 overflow-hidden">
        <DialogHeader className="sticky top-0 z-10 bg-black/95 backdrop-blur-sm border-b border-orange-500/30 px-6 py-4">
          <div className="flex items-center justify-between">
            <DialogTitle className="text-3xl font-bold text-white">
              Full <span className="text-orange-500">Menu</span>
            </DialogTitle>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-orange-500 transition-colors duration-300 p-2 hover:bg-zinc-800 rounded-lg"
            >
              <X className="h-6 w-6" />
            </button>
          </div>
          <p className="text-gray-400 text-sm mt-2">
            Browse our complete menu • Call 020 7833 3399 to order
          </p>
        </DialogHeader>

        <div className="overflow-y-auto max-h-[calc(90vh-100px)] px-6 py-6 space-y-8">
          {menuImages.map((menu, index) => (
            <div key={index} className="space-y-4">
              <h3 className="text-xl font-bold text-orange-500 mb-4">
                {menu.title}
              </h3>
              <div className="relative rounded-xl overflow-hidden border-2 border-zinc-800 hover:border-orange-500/50 transition-all duration-300 shadow-2xl">
                <img
                  src={menu.url}
                  alt={menu.title}
                  className="w-full h-auto object-contain bg-black"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="sticky bottom-0 bg-gradient-to-t from-black via-black to-transparent px-6 py-4 border-t border-orange-500/30">
          <div className="text-center">
            <p className="text-gray-400 text-sm mb-2">
              Ready to order? Call us now!
            </p>
            <a
              href="tel:02078333399"
              className="inline-block bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 text-white font-bold px-6 py-3 rounded-lg transition-all duration-300 hover:scale-105"
            >
              020 7833 3399
            </a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FullMenuModal;
